import React, { useState } from 'react';
import './Contact.css'; 
import { Helmet } from 'react-helmet';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSuccessMessage('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - My Kids Fitness Solutions</title>
        <meta name="description" content="Get in touch with us for any inquiries." />
      </Helmet>
      <div className='Main-sub-heading-div bordered '>
      <h1 className='Main-sub-heading-div-h1'>
          Contact Us
      </h1>
      <p> 
        Feel free to contact us for any inquiries or assistance you may need. 
        Our team is here to help you with your vehicle needs and provide you 
        with the best service possible.
      </p>
    </div>
    <div className="contact-form-container">
        <h2>Contact Us</h2>
        <p>Phone: <a href="tel:+923351908270">+92 33 5190 8270</a></p>
        <p>Email: <a href="mailto:fakharaautos@gmail.com">fakharaautos@gmail.com</a></p>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="submit-button">Send Message</button>
        </form>
        {successMessage && <p className="success-message">{successMessage}</p>}
      </div>

      <div className="contact-container" >
          <h2>Our Location</h2>
          <p>Feel free to reach out to us online or visit us at our location.</p>
      </div>
      

      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.986951881649!2d72.9884475744135!3d33.683402037118405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbdf225f5e093%3A0xe3dc2b1542aa3611!2sFakhar%20Auto%20work%20shop!5e0!3m2!1sen!2s!4v1734887470216!5m2!1sen!2s"
          width="90%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title='Fakhar Autos Workshop Location'
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <style jsx>{`
    
    .contact {
    color: #9a0002 !important;

    }
  `}</style>
    </>
  );
}